import BaseModel from '@core/model';

import i18n from '@plugins/i18n';

import { Address, PhoneNumber } from '@/models';

export class Accountant extends BaseModel {
    static name = 'Accountant';
    static entity = 'accountants';

    static fields() {
        return {
            ...super.fields(),
            id: this.string(null).nullable(),
            title: this.string(null).nullable(),
            name: this.string(null).nullable(),
            firm_name: this.string(null).nullable(),
            email: this.string(null).nullable(),
            phone_number: this.model(PhoneNumber).nullable(),
            address: this.model(Address).nullable()
        };
    }

    get is_valid() {
        return [this.name, this.firm_name, this.email, this.phone_number, this.address].every(v => v);
    }

    get computed_name() {
        if (this.is_valid) {
            return [(this.title ? this.title + ' ' : '') + this.name, this.firm_name].join(' - ');
        }
        return i18n.t('third_party_access');
    }
}

export default Accountant;
